export default {
  cm_v1_root: '/',
  lots: '/lotes',
  publish: '/publish/',
  account: '/account/',
  blog: '/blog',
  profile_buyer: '/account/buyer/',
  profile_seller: '/account/seller/',
  tutorials: '/tutorials/',
  facebook: 'https://www.facebook.com/campomercado.uy/',
  twitter: 'https://twitter.com/campomercado_uy',
  youtube: 'https://www.youtube.com/channel/UCRPpP9a4-z8A6Un038rva1g',
  instagram: 'https://www.instagram.com/campomercado_uy/',
};
